import {
  AirVent,
  ArrowBigUp,
  Bath,
  Building,
  Building2,
  Car,
  ClipboardList,
  Coffee,
  Droplets,
  Dumbbell,
  Fan,
  Flame,
  Leaf,
  Lightbulb,
  Lock,
  LucideIcon,
  Microwave,
  MoveVertical,
  ParkingCircle,
  PlugZap,
  Power,
  ShieldCheck,
  Shirt,
  Sparkles,
  Sun,
  ThermometerSnowflake,
  TreeDeciduous,
  Tv,
  Users,
  Utensils,
  Waves,
  Wifi,
} from "lucide-react";

// Lucide icon cache to avoid re-importing icons
const iconCache: Record<string, LucideIcon> = {};

// Dynamic icon resolver that safely handles missing icons
export const getIconByName = (iconName: string | null): LucideIcon => {
  // Default icon for null or empty names
  if (!iconName) return Lightbulb;

  // Return from cache if it exists
  if (iconCache[iconName]) return iconCache[iconName];

  // Define the icon map for all known icons
  const iconMap: Record<string, LucideIcon> = {
    // Air conditioning & ventilation
    "air-conditioner": AirVent,
    "central-a/c": AirVent, // Specific mapping for Central A/C
    "air-vent": AirVent,

    // Parking related
    "parking-circle": ParkingCircle,
    "covered-parking": ParkingCircle, // Specific mapping for Covered Parking
    car: Car,

    // Utilities & power
    power: Power,
    flame: Flame,
    "plug-zap": PlugZap,

    // Kitchen & food
    sandwich: Utensils,
    utensils: Utensils,
    coffee: Coffee,
    microwave: Microwave,

    // Climate control
    wind: Fan,
    fan: Fan,
    "thermometer-snowflake": ThermometerSnowflake,
    sun: Sun,

    // Movement & transportation
    "move-vertical": MoveVertical,
    "arrow-big-up": ArrowBigUp,

    // Fitness & recreation
    dumbbell: Dumbbell,
    "shared-pool": Waves, // Specific mapping for Shared Pool

    // Clothing & household
    shirt: Shirt,
    bath: Bath,
    "maids-room": Shirt, // Specific mapping for Maids Room
    "walk-in-closet": Shirt, // Specific mapping for Walk-in Closet
    "built-in-wardrobes": Shirt, // Specific mapping for Built in Wardrobes

    // Security & safety
    "shield-check": ShieldCheck,
    security: ShieldCheck, // Specific mapping for Security
    lock: Lock,

    // Water related
    "shower-head": Droplets,
    droplets: Droplets,
    waves: Waves,
    "view-of-water": Waves, // Specific mapping for View of Water

    // Building & spaces
    "concierge-bell": Building2,
    building: Building,
    "building-2": Building2,
    balcony: Building, // Specific mapping for Balcony

    // Electronics & entertainment
    tv: Tv,
    wifi: Wifi,

    // Nature & outdoors
    leaf: Leaf,
    "tree-deciduous": TreeDeciduous,
    "private-garden": TreeDeciduous, // Specific mapping for Private Garden

    // Misc & special effects
    sparkles: Sparkles,
    "clipboard-list": ClipboardList,
    users: Users,

    // Fix for the 'window' icon - use Building as fallback
    window: Building,
  };

  // Convert to lowercase to make it case-insensitive
  const lowerName = iconName.toLowerCase();

  // Store the icon in cache if found
  if (iconMap[lowerName]) {
    iconCache[iconName] = iconMap[lowerName];
    return iconMap[lowerName];
  }

  // For any icon not found, use a default and log for debugging
  // console.log(`Icon not found: ${iconName}, using default`);
  return Lightbulb;
};
